const tabVisibilityHandler = (cb) => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && typeof cb === 'function') {
      console.log('visible');
      cb();
    } else {
      console.log('hidden');
    }
  });
};

export default tabVisibilityHandler;
